let activeFiltersCount = 0
document.addEventListener('DOMContentLoaded', () => {
    const availableCheckbox = document.querySelector('.available-wrap #check-available')
    const collectionFilters = document.querySelectorAll('.collection-filters_filter input[type="checkbox"]')
    const params = new URLSearchParams(window.location.search)

    if (params.has('filter.v.availability') && params.get('filter.v.availability') == 1) {
        availableCheckbox.checked = true
    }

    for (const filter of collectionFilters) {
        const filterParam = filter.getAttribute('data-filter-param')
        const filterValue = filter.getAttribute('name')
        const activeFilters = params.getAll(filterParam)
        if (activeFilters.includes(filterValue)) {
            filter.checked = true
            activeFiltersCount += 1
        } else {
            filter.checked = false
        }
        handleUpdateActiveFilters(activeFiltersCount)
    }
})

window.onclick = function (event) {
    const collectionFiltersModalContainer = document.querySelector('.collection-filters')
    if (event.target == collectionFiltersModalContainer) {
        toggleFilters()
    }
}

const renderPage = async (sectionId) => {
    const urlParams = new URLSearchParams(window.location.search)
    let searchParams = ''

    for (const entry of urlParams.entries()) {
        const [key, value] = entry
        searchParams += `${key}=${value}&`
    }

    const productList = document.querySelector('.product-list-container')
    const collectionProductCount = document.querySelector('.collection-filters_buttons .results_product-count span')
    const url = `${window.location.pathname}?section-id=${sectionId}&${searchParams}`
    try {
        const response = await fetch(url)
        if (response.ok === false) {
          throw new Error(`Fetch "${id}" section response was not OK`);
        }
        const html = await response.text();
        const newDocument = new DOMParser().parseFromString(html, 'text/html');
        productList.innerHTML = newDocument.querySelector('.product-list-container').innerHTML
        collectionProductCount.innerHTML = newDocument.querySelector('.collection_product-count').innerHTML
        handleUpdateActiveFilters(activeFiltersCount)
    } catch (error) {
        console.error(error)
    }
}

const toggleFilters = () => {
    const activeFilterClass = 'active'
    document.querySelector('.collection-filters').classList.toggle(activeFilterClass)
}

const handleChangeFilter = async (filterParam, e, clearFilter = false) => {
    const collectionTemplateSectionID = e.target.closest('.collection-template-section').id
    const params = new URLSearchParams(window.location.search)
    if (!clearFilter) {
        if (e.target.checked) {
            params.append(filterParam, e.target.name)
            params.delete('page')
            activeFiltersCount += 1
        } else {
            const remainingFilter = params.getAll(filterParam).filter(param => param != e.target.name)
            activeFiltersCount -= 1
            if (remainingFilter.length) {
                remainingFilter.forEach(param => {
                    params.set(filterParam, param)
                })
            } else {
                params.delete(filterParam)
            }
            
        }
        const updatedUrl = `${window.location.pathname}?${params.toString()}`;
        history.replaceState(null, null, updatedUrl);
    } else {
        const url = new URL(window.location.href)
        url.search = ''
        history.replaceState(null, null, url.toString())
        document.dispatchEvent(new Event('DOMContentLoaded'))
    }
    await renderPage(collectionTemplateSectionID)
    infiniteScroll.destroy()
    enableInfiniteScroll()
}

const handleClearFilter = async (event) => {
    await handleChangeFilter(null, event, true)
    activeFiltersCount = 0
    handleUpdateActiveFilters(activeFiltersCount)
    toggleFilters()
}

const handleUpdateActiveFilters = (activeFilters) => {
    // Update active filters count
    const activeFiltersCountEl = document.querySelector('.collection-filter-wrap .active-filters-count')
    activeFiltersCountEl.innerHTML = activeFilters
    if (activeFilters > 0) {
        activeFiltersCountEl.classList.remove('zero')
    } else {
        activeFiltersCountEl.classList.add('zero')
    }
}